import { Component, inject, input } from '@angular/core';
import { TrophyRanking } from '@shared/models/recurring-ranking.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { AvatarComponent } from '../../avatar/avatar.component';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'slotcom-ranking-item',
  templateUrl: './ranking-item.component.html',
  styleUrls: ['./ranking-item.component.scss'],
  standalone: true,
  imports: [AvatarComponent, SharedModule],
})
export class RankingItemComponent {
  rankingUser = input<TrophyRanking>();
  isUser = input<boolean>();
  stickyTop = input<boolean>();
  stickyBottom = input<boolean>();
  hiddenInList = input<boolean>(false);

  private eventManager = inject(EventManager);

  publicProfile() {
    if (!this.isUser()) {
      this.eventManager.openModal(
        new Modal(
          NonPersistedModalName.PublicProfileComponent,
          ModalType.View,
          { userId: this.rankingUser().userId },
          'big-dialog'
        )
      );
    }
  }
}
